export const adminIntercomKeys = {
  // Bez kursora w kluczu: strony trzyma `useInfiniteQuery`, a wspólny klucz pozwala im się kleić
  // w jedną listę. Kursor w kluczu rozbiłby każdą stronę na osobny wpis w cache.
  contacts: (query: string, tagIds: string[]) => ['admin', 'intercom', 'contacts', query, tagIds.join(',')] as const,
  contact: (contactId: string) => ['admin', 'intercom', 'contact', contactId] as const,
  tags: ['admin', 'intercom', 'tags'] as const,
};
